import { render } from "./KitchenOrdersModal.vue?vue&type=template&id=46ea28eb"
import script from "./KitchenOrdersModal.vue?vue&type=script&lang=js"
export * from "./KitchenOrdersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__